import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {ConceptListItem} from '../../../core/definitions/concepts';
import {ConceptField} from '../../admin-concept-lists/concept-field';
import {ConceptsContainer} from '../../../core/definitions/concepts-container';
import {ConceptService} from '../../../core/concept.service';
import {ConceptDialogService, OpenConceptParams} from '../../admin-concept-lists/concept-dialog.service';
import {DateToolsService} from '../../../core/date-tools.service';
import {FeatureFlagsService} from '../../../core/feature-flags.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';

@Component({
    selector: 'app-admin-list-item-special-value',
    templateUrl: './admin-list-item-special-value.component.html',
    styleUrls: ['./admin-list-item-special-value.component.scss'],
    standalone: false
})
export class AdminListItemSpecialValueComponent implements OnInit {
  // Injections
  private readonly conceptService: ConceptService = inject(ConceptService);
  private readonly conceptDialogService: ConceptDialogService = inject(ConceptDialogService);
  private readonly dateTools: DateToolsService = inject(DateToolsService);
  private readonly featureFlags: FeatureFlagsService = inject(FeatureFlagsService);
  private readonly dialog: MatDialog = inject(MatDialog);

  @Input() value: any;
  @Input() concept: ConceptListItem;
  @Input() conceptField: ConceptField;
  @Input() conceptsContainer: ConceptsContainer;
  @Input() index: number;
  @Output() conceptOpened = new EventEmitter<any>();
  @Output() updateConceptList = new EventEmitter<void>();

  get useNewObjectPage() {
    let res= this.featureFlags.getFeatureFlags()?.experimental?.useNewObjectPage;
    if (this.conceptsContainer.linkToObject === '/profile') {
      res = true;
    }
    return res;
  }

  ngOnInit(): void {
    if (this.conceptField.type === 'datetime') {
      this.value = this.dateTools.isoDateToString(this.value, 'datetime');
    }
  }

  get parentId() {
    const parentConcept = this.conceptService.getParentConcept(this.conceptsContainer, 1);
    return parentConcept ? parentConcept.artifact_id : undefined;
  }

  openConcept(conceptId: string, goBack: boolean) {
    this.conceptService.clearSelected(this.conceptsContainer);
    if (!goBack) {
      this.conceptsContainer.parentConcepts.push(this.concept);
    } else {
      this.conceptsContainer.parentConcepts.pop();
    }
    this.conceptOpened.emit({conceptId: conceptId, goBack: goBack, pageIndex: !goBack ? this.conceptsContainer.pageIndex : null});
  }

  openParent() {
    if (!this.parentId || this.concept.parent_id === this.parentId) {
      this.openConcept(this.parentId, true);
    } else {
      let goOnMate = true;
      do {
        const parentConcept = this.conceptsContainer.parentConcepts[this.conceptsContainer.parentConcepts.length - 1];
        if (parentConcept.artifact_id !== this.concept.artifact_id) {
          this.conceptsContainer.parentConcepts.pop();
        } else {
          goOnMate = false;
        }
      } while (goOnMate);
      this.openConcept(undefined, true);
    }
  }

  select(event: any) {
    this.conceptService.selectConcept(this.concept, this.conceptsContainer, event.shiftKey);
  }

  async editTerm() {
    if (this.concept.object_type === 'agent') {
      console.log('Show dialog here');
      const dialog = this.dialog.open(ConfirmationModalComponent, {
        data: {
          cancelButtonText: 'TRANS__AGENT__CHANGE__WARNING_CANCEL',
          confirmButtonText: 'TRANS__AGENT__CHANGE__WARNING_CONFIRM',
          content: 'TRANS__AGENT__CHANGE__WARNING__CONTENT',
          hideDontShowAgain: true,
          title: 'TRANS__AGENT__CHANGE__WARNING__TITLE',
        }
      });

      dialog.afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.openConceptDialog();
        }
      })
    }
    else {
      this.openConceptDialog();
    }
  }

  private openConceptDialog() {
    const params: OpenConceptParams = {
      conceptsContainer: this.conceptsContainer,
      concept: null,
      concept_id: this.concept.artifact_id,
      index: this.index,
      callback: (stored: boolean) => {
        if (stored) {
          this.updateConceptList.emit();
        }
      }
    };
    this.conceptDialogService.openConcept(params);
  }

  async addChildConcept() {
    const childConcept = await this.conceptService.createChildConcept(this.conceptsContainer, this.concept);
    this.conceptDialogService.openConcept({
      conceptsContainer: this.conceptsContainer,
      concept: childConcept,
      concept_id: null,
      index: -1,
      callback: (stored: boolean) => {
        if (stored) {
          this.openConcept(this.concept.artifact_id, false);
        }
      }
    });
    this.concept.open = true;
  }

}
